const isText = RegExp(/^[A-Z ]+$/i);
const isString = RegExp(/^[A-Z]+$/i);
const isEmail = RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
const isUsername = RegExp(/^[a-zA-Z0-9_]+$/i);
const isNumber = RegExp(/^\d+$/);
const isPassword = RegExp(/^[a-zA-Z0-9!@#$%^&*]+$/i);

const hasLowerCase = RegExp(/(.*[a-z].*)/);
const hasUpperCase = RegExp(/(.*[A-Z].*)/);
const hasDigit = RegExp(/(.*\d.*)/i);
const hasSpecial = RegExp(/(.*\W.*)/i);


export default function formValidation(name, value, schema) {
    const {validate, minLength, maxLength} = schema[name];
    let error = null;

    if (minLength && value.length < minLength)
        error = `Minimum ${minLength} characters is required.`;
    else if (maxLength && value.length > maxLength)
        error = `Maximum length of ${maxLength} exceeded!`;
    if (!validate) return;

    switch (validate) {
        case "text":
            if (!isText.test(value)) error = "This field accept text only.";
            break;
        case "string":
            if (!isString.test(value)) error = "This field accept text only.";
            break;
        case "number":
            if (!isNumber.test(value)) error = "This field accept A-Z only.";
            break;
        case "email":
            if (!isEmail.test(value)) error = "Please enter a valid email";
            break;
        case "username":
            if (!isUsername.test(value)) error = "This field accept letters, numbers, underline only";
            break;
        case "password":
            if (!isPassword.test(value)) error = "Please enter a valid password";
            break;
        case "strongPassword":
            if (!hasLowerCase.test(value)) {
                error = "Please enter lowercase character";
                break;
            }
            if (!hasUpperCase.test(value)) {
                error = "Please enter uppercase character";
                break;
            }
            if (!hasDigit.test(value)) {
                error = "Please enter number";
                break;
            }
            if (!hasSpecial.test(value)) {
                error = "Please enter special character";
                break;
            }
            break;
        default:
            break;
    }

    return error;
}